/** Per-user chat alert settings (stored in users.preferences.chatAlerts, cached in localStorage on the web). */
export interface ChatAlertPrefs {
  /** Play a short sound for new inbound customer messages. */
  sound: boolean;
  /** 0–100. */
  volume: number;
  /** Browser (desktop) notification while the tab is hidden; still needs the browser permission. */
  desktop: boolean;
  /** In-app notification card. */
  toast: boolean;
}

export const CHAT_ALERT_DEFAULTS: ChatAlertPrefs = { sound: true, volume: 70, desktop: false, toast: true };

export interface UserPreferences {
  chatAlerts: ChatAlertPrefs;
}

/** Tolerant read of a stored/unknown value: invalid fields fall back to defaults. */
export function normalizeChatAlertPrefs(raw: unknown): ChatAlertPrefs {
  const r = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>;
  const bool = (v: unknown, d: boolean) => (typeof v === 'boolean' ? v : d);
  const vol = typeof r.volume === 'number' && Number.isFinite(r.volume) ? Math.min(100, Math.max(0, Math.round(r.volume))) : CHAT_ALERT_DEFAULTS.volume;
  return {
    sound: bool(r.sound, CHAT_ALERT_DEFAULTS.sound),
    volume: vol,
    desktop: bool(r.desktop, CHAT_ALERT_DEFAULTS.desktop),
    toast: bool(r.toast, CHAT_ALERT_DEFAULTS.toast),
  };
}
